<template>
  <Badge
    :label="t('components.asset_create.unique_id.label')"
    type="modern"
    border="dashed"
    size="sm"
    icon
    class="cursor-pointer mr-auto"
  >
    <Icon name="plus" />
  </Badge>
</template>

<script setup>
import { Icon } from "@/SharedComponents/Icon";
import { Badge } from "@/SharedComponents/Badges";
import { useI18n } from "vue-i18n";

// Translations
const { t } = useI18n();
</script>
